const hudManager = {
  init(bet) {
    this.hud = document.querySelector('#hud');
    this.balance = document.querySelector('#hud-balance');
    this.bet = document.querySelector('#hud-bet');

    this.hud.hidden = false;
    this.setBet(bet);
  },

  setValidState(valid) {
    this.bet.classList[valid ? 'remove' : 'add']('hud__field--error');
  },

  setBalance(balance) {
    this.balance.innerText = `Баланс: ${balance} G`;
  },

  setBet({ currentBet }) {
    this.bet.innerText = `Общая ставка: ${currentBet} G`;
  },
};

export default hudManager;



// WEBPACK FOOTER //
// ../base/js/managers/hud.js